<template>
    <div class="wrapper-scroll">
        <Loading :show="showLoading"></Loading>
        <v-app>
            <router-view></router-view>
            <notifications group="app" :max="3">
                <template slot="body" slot-scope="props">
                    <div
                            :class="[
                            props.item.classes,
                            props.item.type,
                            'vue-notification-template',
                            'vue-notification',
                            'custom-notification'
                         ]"
                            @click="props.close"
                    >
                        <div class="icon-container">
                            <v-icon color="#fff" size="30">
                                {{props.item.type === 'error' ? 'mdi-alert' : 'mdi-check'}}
                            </v-icon>
                        </div>
                        <div v-if="props.item.title"
                             class="notification-title"
                             v-html="props.item.title">
                        </div>
                        <div class="notification-content centerY" v-html="props.item.text"></div>
                    </div>
                </template>
            </notifications>
            <DialogConfirm></DialogConfirm>
           <vue-confirm-dialog></vue-confirm-dialog>
        </v-app>
    </div>
</template>
<script>
import {EventBus, EventBusType} from '@/services/eventbus'
import DialogConfirm from "@/components/dialog/DialogConfirm";
import Loading from "./components/Loading";
import {mapActions, mapState} from "vuex";

    export default {
        name: 'App',
        components: {Loading, DialogConfirm },
        async mounted() {
            EventBus.$on(EventBusType.TOAST, options => {
                this.$notify(options)
            });
            // request notification permission from browser
            if ("Notification" in window) {
                if (Notification.permission !== "granted") {
                    await Notification.requestPermission();
                }
            } else {
                // This browser does not support desktop notification
            }
            let botCode = this.$route.params.botCode;
            if (botCode) {
                this.getBotConfig(botCode)
            }
        },
        computed: {
          ...mapState('loading', ['showLoading'])
        },
        methods: {
            ...mapActions('config', ['getBotConfig'])
        },
        watch: {
            "$route.params.botCode": {
                handler(val) {
                    if (val) {
                        this.getBotConfig(val)
                    }
                }
            }
        }
    };
</script>
<style lang="scss" src="./styles/tm.scss"></style>
<style lang="scss">
    .custom-notification{
        display: flex !important;
    }
    html, body {
        width : 100%;
        height : 100%;
        margin : 0;
        padding : 0;
        overflow: hidden !important;
    }

    .wrapper-scroll {
        width: 100%;
        height: 100%;
        overflow: auto;
    }

    #app {
        width      : 100%;
        max-width  : 100%;
        min-width  : inherit;
        height     : 100%;

        * {
            font-family: 'Open Sans', sans-serif;
        }
    }

    .application .application--wrap {
        height : 100%;
        min-height : 100%;
    }

    .v-btn {
        text-transform: none;
        font-weight: 500;
        font-size: 16px;
    }

    .vue-notification-group {
        padding-right: 20px;
        margin-top: 65px;
    }

    .vue-notification-group .vue-notification-template {
        box-shadow: 0 3px 6px #00000029;
        border-radius: 5px;
        margin: 5px;
        border: 0;
        min-height: 62px;
        display: flex;
        padding: 0;
        font-size: 14px;

        .icon-container {
            flex: 0 0 62px;
            width: 62px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 5px 0 0 5px;
        }

        &.error {
            background-color: #E53737 !important;

            .icon-container {
                background: #F04B4B;
            }
        }

        &.success {
            background-color: #19AB66 !important;

            .icon-container {
                background: #20BA72;
            }
        }

        &.info {
            background-color: #19AB66 !important;

            .icon-container {
                background: #20BA72;
            }
        }

        .notify-btn {
            background: rgba(0,0,0,0.5);
            width: fit-content;
            height: fit-content;
            padding: 0 5px;
            border-radius: 5px;
            cursor: pointer;
        }
    }

    .notification-content {
        padding: 10px;
        flex: 1;
    }

    #app .v-badge__badge {
        width: 20px;
        height: 20px;
    }

    .always-top {
        z-index: 1000 !important;
    }
</style>
